import { ExperienceLevelEnum } from '../lib/constants/constants';
import { ApiResponseType } from './api';
import { MarketPlaceCandidateFormData } from './candidate';
import { CompanyStatus, CompanyType } from './claimed';

export enum SocialEnum {
    microsoft,
    google,
    linkedIn,
    amazon,
    CustomAuth,
    hrms,
}
export type SocialEnumKeyType = keyof typeof SocialEnum;

export enum HighestEducationEnum {
    HighSchoolDiploma = 1,
    AssociateDegree = 2,
    BachelorsDegree = 5,
    MastersDegree = 6,
    DoctorateDegree = 7,
}

export enum UserRoleEnum {
    manager,
    candidate,
    admin,
    hrms,
}
export enum ScreenXManagerPermissionEnum {
    Admin = 2,
    Scheduler = 3,
    Contributor = 4,
    Approver = 5,
    Evaluator = 6,
}
export enum GenderEnum {
    male,
    female,
    preferNotToDisclose,
    Unavailable,
}

export enum ManagerPermissionEnum {
    admin,
    offerManager,
    owner,
    hrms,
}

export enum HRMSManagerPermissionEnum {
    admin,
    hrms,
}

export type socialSignInType = {
    Email: string;
    AuthType: SocialEnum;
    Token: string;
    Location: string;
    Password?: string;
};

type CandidateFormsType = {
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email?: string;
    JobTitle: string;
    CityDistrict: string | null;
    state: string | null;
    country: string;
    Dob: Date;
    Gender: GenderEnum;
    Phone: string;
    Password?: string;
    Aadhar: string;
    HighestEducation: HighestEducationEnum | string | null;
    ExperienceLevel: ExperienceLevelEnum | string | null;
    PrevCompany: string;
    IsCandidateTermsChecked: boolean;
    flatAddress: string;
    streetAddress: string;
    CandidateAddress: string;
    PostalCode: string;
    GraduationYear: string | number;
    InstitutionName: string;
    UserCountryCode: string;
    kycRequestId?: string;
};

type CandidateFormsTypeStep2 = {
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email: string;
    CityDistrict: string;
    state: string;
    country: string;
    Dob: Date | string;
    Gender: GenderEnum;
    Phone: string;
    flatAddress: string;
    streetAddress: string;
    PostalCode: string;
    UserCountryCode: string;
};

export type CandidateFormDataStep2 = Omit<CandidateFormsTypeStep2, 'Dob' | 'Gender'> & {
    Dob: Date | string | null;
    Gender: GenderEnum | undefined;
    flatAddress: string;
    streetAddress: string;
    PostalCode: string;
};

export type CandidateFormData = Omit<
    CandidateFormsType,
    'Dob' | 'Gender' | 'HighestEducation' | 'ExperienceLevel' | 'IsCandidateTermsChecked'
> & {
    Dob: Date | string | null;
    Gender: GenderEnum | undefined;
    HighestEducation: HighestEducationEnum | string | null;
    ExperienceLevel: ExperienceLevelEnum | string | null;
    IsCandidateTermsChecked: boolean;
};

export type CandidateRequestType = CandidateFormsType & {
    InvitationId?: string;
    AuthType: SocialEnum;
    Token: string;
};

export type MarketPlaceCandidateRequestType = MarketPlaceCandidateFormData & {
    AuthType: SocialEnum;
    Token: string;
};

export type ManagerFormsType = {
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email: string;
    CompanyName: string;
    GstNumber: string | null;
    CompanyAddress: string;
    CityDistrict: string | null;
    state: string | null;
    country: string;
    PostalCode: string;
    Password: string;
    CompanyEmail: string;
    Phone: string;
    Website: string;
    ReferralCode: string;
    cinNumber: string;
    IsCompanyTermsChecked: boolean;
    Address2: string;
    OwnerPhoneNumber: string;
    CompCountryCode: string;
    OwnerCountryCode: string;
    isAffiliate?: boolean;
    companyStatus?: CompanyStatus;
    companyType?: CompanyType;
    companyId?: string;
};

export type HrmsManagerFormsType = {
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email: string;
    CompanyName: string;
    gstNumber?: string | null;
    CompanyAddress: string;
    CityDistrict: string | null;
    state: string | null;
    country: string;
    PostalCode: string;
    Password: string;
    CompanyEmail: string;
    phone: string;
    webSite: string;
    ReferralCode: string;
    cinNumber?: string | null;
    IsCompanyTermsChecked: boolean;
    Address2: string;
    OwnerPhoneNumber: string;
    CompCountryCode: string;
    OwnerCountryCode: string;
};

export type ManagerFormsTypeStep2 = {
    FirstName: string;
    LastName: string;
    Email: string;
    CompanyName: string;
    // GstNumber: string | null;
    CompanyEmail: string;
    LinkedINUrl: string;
    Phone: string;
    // cinNumber: string;
    Website: string;
    CompCountryCode: string;
    OwnerCountryCode: string;
    MiddleName?: string;
    OwnerPhoneNumber?: string;
};

export type ManagerStepOneFormsType = {
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email: string;
    CompanyName: string;
    GstNumber: string | null;
    CompanyEmail: string;
    Phone: string;
    WebSite: string;
};

export type ManagerRequestType = ManagerFormsType & {
    AuthType: SocialEnum;
    Token: string;
};

export type HrmsManagerRequestType = HrmsManagerFormsType & {
    AuthType: SocialEnum;
    Token: string;
};

export type ManagerJoinByInvitationType = {
    Email: string;
    InvitationId: string;
};

export type AuthResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        accessToken: string;
        authType: any;
        userEmail: string;
        isSuccessful: boolean;
    };
};

export type UserType = {
    id: string;
    active: boolean;
    email: string;
    role: UserRoleEnum;
    firstName: string;
    lastName: string;
    middleName: string;
    website: string;
    jobTitle: string | null;
    rating: {
        value: number;
    };
    companyId: string | null;
    companyName: string | null;
    companyEmail: string | null;
    docUri: string;
    avatarUrl: string;
    permissionTypes: ManagerPermissionEnum[] | null;
    offerCount: number;
    pendingOfferCount: number;
    acceptedOfferCount: number;
    isOffboardingReviewsEnabled: boolean;
    onboardedOfferCount: number;
    ghostedOfferCount: number;
    declinedOfferCount: number;
    retractedOfferCount: number;
    policyDocumentId: string;
    digioExternalId: string;
    expiredOfferCount: number;
    suspendedStatus: number;
    ownerPhoneNUmber: string;
    ownerCountryCode: string;
    accountLinkedStatus: boolean;
    authType: SocialEnum;
    migrateCount: number;
    esignatureStatus: number;
    isPolicyUpdated: boolean;
    isConsentFeatureEnabled: boolean;
    isCOEEnabled: boolean;
    joinStatus: number;
    editReviewEnabled: boolean;
    editReviewEnabledTimesHours: number;
    country: string;
    dataPunched: number;
    dataPunchedGhosted: number;
    dataPunchedOnboarded: number;
    dataPunchedRetracted: number;
};

export type HRMSUserType = {
    id: string;
    active: boolean;
    email: string;
    role: UserRoleEnum;
    firstName: string;
    lastName: string;
    middleName: string;
    website: string;
    jobTitle: string | null;
    rating: {
        value: number;
    };
    companyId: string | null;
    companyName: string | null;
    companyEmail: string | null;
    docUri: string;
    avatarUrl: string;
    permissionTypes: HRMSManagerPermissionEnum[] | null;
    offerCount: number;
    pendingOfferCount: number;
    acceptedOfferCount: number;
    isOffboardingReviewsEnabled: boolean;
    onboardedOfferCount: number;
    ghostedOfferCount: number;
    declinedOfferCount: number;
    retractedOfferCount: number;
    policyDocumentId: string;
    digioExternalId: string;
    expiredOfferCount: number;
    suspendedStatus: number;
    ownerPhoneNUmber: string;
    ownerCountryCode: string;
    accountLinkedStatus: boolean;
    authType: SocialEnum;
    migrateCount: number;
    esignatureStatus: number;
    isPolicyUpdated: boolean;
    isConsentFeatureEnabled: boolean;
    isCOEEnabled: boolean;
    joinStatus: number;
    editReviewEnabled: boolean;
    editReviewEnabledTimesHours: number;
};

export type UserResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: UserType;
};

export type HRMSUserResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: HRMSUserType;
};

export type LinkedinResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        firstName: string;
        lastName: string;
        emailAddress: string;
        accessToken: string;
    };
};

export type verifyAndSignInType = {
    param: string | null | undefined;
    candidateEmail: string;
    userEmail: string;
};

export type AutoSignInAuthResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        accessToken: string;
        authType: any;
        userEmail: string;
        isSuccessful: boolean;
        candidateId: string;
        companySuspendStatus: number;
    };
};
